/**
 * Formats time difference in milliseconds to a human-readable string
 * Returns "X min" format (without "ago")
 * @param diffMs - Time difference in milliseconds
 * @returns Formatted string like "2 days", "3 hours", "45 min", or "just now"
 */
function formatTimeDifference(diffMs: number): string {
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffDays > 0) {
    return `${diffDays} ${diffDays === 1 ? 'day' : 'days'}`;
  } else if (diffHours > 0) {
    return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'}`;
  } else if (diffMinutes > 0) {
    return `${diffMinutes} min`;
  } else {
    return '1 min';
  }
}

/**
 * Formats an ISO timestamp string to "X min" format
 * Calculates time difference from now to the given timestamp
 * Example: "2026-01-08T13:23:00.000Z" -> "56 min"
 */
export function formatTimeAgoString(isoString: string): string {
  const date = new Date(isoString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  return formatTimeDifference(diffMs);
}

/**
 * Calculates time difference between start time and submission time
 * Returns "X min" format relative to start time
 * Example: startTime "1:00", submissionTime "1:20" -> "20 min"
 */
export function formatTimeAgoFromStart(
  startTime: string,
  submissionTime: string
): string {
  const startDate = new Date(startTime);
  const submissionDate = new Date(submissionTime);
  const diffMs = submissionDate.getTime() - startDate.getTime();

  return formatTimeDifference(diffMs);
}
